import { ScreenShareSettingContent } from "modules/Call/components/ScreenShareSettingContent"
import { browser } from "utils"

interface Props {
    onClose?: () => void
}

const screenShareManualUrl = "https://psyalter.helpdeskeddy.com/ru/knowledge_base/art/334/cat/30/"

const IOSandMACOSInstruction = (
    <>
        Системные настройки &quot; Конфиденциальность и&nbsp;безопасность &quot; Запись экрана
        &quot; {browser.browser.name} &quot; Вкл
        <br />
        После того, как вы&nbsp;сделаете настройку, перезапустите браузер.
    </>
)

export const ScreenShareSettingManual = (props: Props) => {
    switch (browser.os.name) {
        case "macOS":
            return (
                <ScreenShareSettingContent
                    instruction={IOSandMACOSInstruction}
                    instructionUrl={screenShareManualUrl}
                    settingsUrl="x-apple.systempreferences:com.apple.preferences.sharing?Services_ScreenSharing"
                    onClose={props.onClose}
                />
            )
        case "iOS":
            return (
                <ScreenShareSettingContent
                    instruction={IOSandMACOSInstruction}
                    instructionUrl={screenShareManualUrl}
                    settingsUrl="App-prefs://prefs:root=Privacy"
                    onClose={props.onClose}
                />
            )
        case "Windows":
            return (
                <ScreenShareSettingContent
                    instruction={
                        <>
                            Дайте доступ к&nbsp;экрану в&nbsp;настройках браузера.
                            <br />
                            После того, как вы&nbsp;сделаете настройку, перезапустите браузер.
                        </>
                    }
                    instructionUrl={screenShareManualUrl}
                    onClose={props.onClose}
                />
            )
        case "Linux":
            return (
                <ScreenShareSettingContent
                    instruction={<>Дайте доступ к&nbsp;экрану в&nbsp;открывшемся окне.</>}
                    instructionUrl={screenShareManualUrl}
                    onClose={props.onClose}
                />
            )
        default:
            return (
                <ScreenShareSettingContent
                    instruction={<>Разрешите доступ к&nbsp;экрану.</>}
                    instructionUrl={screenShareManualUrl}
                    onClose={props.onClose}
                />
            )
    }
}
